export default "__VITE_ASSET__c1b86d56__"